import { render, staticRenderFns } from "./ReferenceList.vue?vue&type=template&id=31a503a8&"
import script from "./ReferenceList.vue?vue&type=script&lang=js&"
export * from "./ReferenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports